import { Chip } from '@mui/material';
import { CampaignStatus } from 'generated-graphql/graphql';
import { CampaignStatus as DeprecatedCampaignStatus } from 'services/campaign/types';
import { useStatusProps } from 'pages/Campaigns/hooks/useStatusProps';
import React from 'react';

type Props = {
  status: CampaignStatus | DeprecatedCampaignStatus;
  messagesProcessedCount?: number | null;
  totalProspectsCount?: number | null;
};

export const CampaignStatusChip: React.FC<Props> = ({
  status,
  totalProspectsCount,
  messagesProcessedCount
}) => {
  const {
    text: statusText,
    color,
    backgroundColor,
    icon
  } = useStatusProps(status, {
    messagesProcessedCount,
    totalProspectsCount
  });

  return (
    <Chip
      icon={icon ? icon : undefined}
      label={statusText}
      sx={{
        color,
        backgroundColor
      }}
    />
  );
};
